export enum Status {
	PENDING = "PENDING",
	APPROVED = "APPROVED",
	DENIED = "DENIED",
	OUTDATED = "OUTDATED",
	REJECTED = "REJECTED",
}
